import React, { useState, useEffect } from 'react';

import { activeExamRound } from 'GraphQL/query/mockSchool/LinkSchool.query';
import { mockExamStudentProfile } from 'GraphQL/query/MockExamManage.query';
import { queryDepartmentDetails } from 'GraphQL/query/Department.query';

export function useMyMockWishDepartmentData(apolloClient) {
  const [departmentData, setDepartmentData] = useState({});
  const [studentProfileData, setStudentProfileData] = useState({});

  useEffect(() => {
    (async () => {
      const {
        data: { mockExamSchoolActiveRound },
      } = await apolloClient.query({ query: activeExamRound });
      const { roundId, roundCode } = mockExamSchoolActiveRound; // mockExamSchoolActiveRound;

      const {
        data: { mockExamStudentProfile: studentProfile },
      } = await apolloClient.query({
        query: mockExamStudentProfile,
        variables: { roundCode },
      });

      if (studentProfile !== null && studentProfile !== undefined) {
        setStudentProfileData(studentProfile);

        const { departmentId } = studentProfile;
        if (departmentId !== null && departmentId !== undefined) {
          const {
            data: { department: deptData },
          } = await apolloClient.query({
            query: queryDepartmentDetails,
            variables: {
              depId: departmentId,
              showEvents: false,
              includeRound: true,
              roundDetails: true,
              showLikes: false,
            },
          });

          setDepartmentData(deptData);
        }
      }
    })();
  });

  return { departmentData, studentProfileData };
}
